// src/components/DatabaseExplorer/databaseExplorerUtils.js

export const getColumnName = (column) => column?.Field || column?.name || "";

export const getColumnType = (column) =>
  String(column?.Type || column?.type || "").toLowerCase();

export const getFilterType = (column) => {
  const type = getColumnType(column);

  if (type.includes("datetime") || type.includes("timestamp")) {
    return "datetime";
  }

  if (type === "date") {
    return "date";
  }

  if (/^(bool|boolean)/.test(type)) {
    return "boolean";
  }

  if (/^(enum|set)\(/.test(type)) {
    return "enum";
  }

  const baseType = type.replace(/\([^)]*\)/g, "");

  if (
    [
      "int",
      "integer",
      "bigint",
      "smallint",
      "mediumint",
      "tinyint",
      "decimal",
      "numeric",
      "float",
      "double",
      "real",
      "year",
    ].includes(baseType)
  ) {
    // tinyint(1) is often used for boolean values.
    if (/^tinyint\s*\(\s*1\s*\)/.test(type)) {
      return "boolean";
    }

    return "number";
  }

  return "text";
};

export const isPrimaryKey = (column) =>
  column?.Key === "PRI" || column?.key === "PRI";

export const isAutoGenerated = (column) => {
  const extra = String(column?.Extra || column?.extra || "").toLowerCase();

  return extra.includes("auto_increment") || extra.includes("generated");
};

export const formatHeader = (name) =>
  String(name || "")
    .replace(/_/g, " ")
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/\b\w/g, (letter) => letter.toUpperCase());

export const displayValue = (value) => {
  if (value === null || value === undefined || value === "") {
    return "—";
  }

  if (typeof value === "object") {
    return JSON.stringify(value);
  }

  return String(value);
};

export const extractColumns = (response) => {
  const body = response?.data;
  if (Array.isArray(body?.columns)) return body.columns;
  if (Array.isArray(body?.data?.columns)) return body.data.columns;

  return [];
};

export const extractRows = (response) => {
  const body = response?.data;

  if (Array.isArray(body?.data)) return body.data;
  if (Array.isArray(body?.rows)) return body.rows;
  if (Array.isArray(body?.records)) return body.records;
  if (Array.isArray(body?.result)) return body.result;
  if (Array.isArray(body?.data?.rows)) return body.data.rows;

  return [];
};

export const getErrorMessage = (error) =>
  error?.response?.data?.message ||
  error?.response?.data?.error ||
  error?.message ||
  "Unable to retrieve database information.";

export const getEnumOptions = (type) => {
  const match = String(type || "").match(/^(?:enum|set)\((.*)\)$/i);

  if (!match) return [];

  const options = [];
  const regex = /'((?:\\.|[^'])*)'/g;
  let result;

  while ((result = regex.exec(match[1])) !== null) {
    options.push(result[1].replace(/\\'/g, "'").replace(/\\\\/g, "\\"));
  }

  return options;
};
